import { useRouter } from 'next/router';
import usePageMountEffect from './usePageMountEffect';

const useRemoveQuery = (paramsToRemove: string[]) => {
  const router = useRouter();

  usePageMountEffect(() => {
    const { pathname, query } = router;
    const newQuery = { ...query };

    if (paramsToRemove?.length) {
      paramsToRemove.forEach(param => {
        delete newQuery[param];
      });
    }

    router.replace(
      {
        pathname,
        query: newQuery
      },
      undefined,
      { shallow: true }
    );
  }, []);
};

export default useRemoveQuery;
